<div class="home-main">
  <div class="sidebar">
    <app-sidebar
      (headingEvent)="receiveHeading($event)"
      (toggleSidebarEvent)="receiveSidebarEvent($event)"
    />
  </div>

  <div class="patent_cat" *ngIf="subcatNews.length > 0"
    [ngClass]="toggle_sidebar ? 'main_content_2' : 'main_content_1'">
    <div class="bg_1 p-x-40 p-y-17 dis_flex font_13 weight_600">
      <div
        class="dis_flex align_center color_blue cursor_pointer"
        (click)="goBackTocategories()"
      >
        Back to Sub Categories
      </div>
      <div class="dis_flex align_center p-x-16">
        <svg
          width="7"
          height="8"
          viewBox="0 0 7 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.31367 7.85721L6.7222 4.44452C6.80933 4.38951 6.87927 4.32127 6.92722 4.24449C6.97517 4.1677 7 4.08419 7 3.99968C7 3.91517 6.97517 3.83165 6.92722 3.75487C6.87927 3.67809 6.80933 3.60985 6.7222 3.55484L1.31367 0.142143C0.797419 -0.18355 0 0.0864778 0 0.58698L0 7.41335C0 7.91386 0.797419 8.18388 1.31367 7.85721Z"
            fill="#303030"
          />
        </svg>
      </div>
      <div class="dis_flex align_center color_blue cursor_pointer">
        {{ subCategoryName.name }}
      </div>
    </div>
    <div class="patent_cat_body">
      <div class="dis_flex align_stretch flex_wrap">
        <ng-container *ngFor="let news of subcatNews">
          <div class="patent_cat_body_item p-top-40 p-x-20">
            <div
              class="bg_1 border-radius-20 height_100_per cursor_pointer"
              (click)="goToNewsDetail(news.slug || news._id)"
            >
              <img
                class="patent_cat_body_item_img"
                [src]="filePath + news.thumbnailImage"
              />
              <div class="p-24 color_black">
                <div class="font_12 weight_500">
                  {{ news.createdAt | date }}
                </div>
                <div class="p-top-8 font_16 weight_600">
                  {{ news.title }}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
